import {
  getGridState as getGridStateSvc,
  setGridState as setGridStateSvc,
  resetGridState as resetGridStateSvc
} from 'app/services/gridState';

import {
  SET_GRID_STATE,
  RESET_GRID_STATE
} from 'app/actions/types';

export const getGridState = (accountId, resource) => async dispatch => {
  let gridState = await getGridStateSvc(accountId, resource);

  dispatch({
    type: SET_GRID_STATE,
    payload: gridState
  });

  return gridState;
}

export const setGridState = (accountId, resource, params) => async dispatch => {
  let gridState = await setGridStateSvc(accountId, resource, params);

  dispatch({
    type: SET_GRID_STATE,
    payload: gridState
  });

  return gridState;
}

export const resetGridState = (accountId, resource) => async dispatch => {
  await resetGridStateSvc(accountId, resource);

  dispatch({
    type: RESET_GRID_STATE,
    payload: {
      account_id: accountId,
      resource
    }
  });
}
